//Globalní proměnné
// na kraztší zjištění stránky a jazyka
import { } from './translate.js';


window.shoptetPage = dataLayer[0].shoptet.pageType;
window.shoptetLang = dataLayer[0].shoptet.language;
window.body = document.querySelector('body');

// přesunování elementů
function moveElement(elementSelector, targetSelectors) {
	const element = document.querySelector(elementSelector);
	const footer = document.querySelector('footer');

	if (!element) {
		console.error(`Prvek ${elementSelector} nebyl nalezen`);
		return;
	}

	let moved = false;

	for (const targetSelector of targetSelectors) {
		const target = document.querySelector(targetSelector);
		if (target) {
			target.insertAdjacentElement('afterend', element);
			moved = true;
			break;
		}
	}

	if (!moved && footer) {
		footer.insertAdjacentElement('beforebegin', element);
	}
}

// Přiřazení funkce k objektu window pro globální dostupnost
window.moveElement = moveElement;


//On funkce, na kliknutí a zavolání funkce
function on(eventType, selector, callback) {
	document.addEventListener(eventType, function (e) {
		let targetElement = e.target;
		while (targetElement && targetElement !== document) {
			if (targetElement.matches(selector)) {
				e.preventDefault();
				callback.call(targetElement, e);
				break;
			}
			targetElement = targetElement.parentElement;
		}
	});
}

//z hrefu na další sekci
function scrollToNextSectionOrHref(e) {
	if (this.getAttribute('href') === '#next') {
		e.preventDefault();
		scrollToNextSection.call(this);
	}
}



// window.addEventListener('load', () => document.body.classList.add('hideSpinner'))
const debounce = (func, delay) => {
	let debounceTimer
	return function () {
		const context = this
		const args = arguments
		clearTimeout(debounceTimer)
		debounceTimer = setTimeout(() => func.apply(context, args), delay)
	}
}

const currentPath = window.location.pathname
const links = document.querySelectorAll('.menu-level-1 li a')
links.forEach((link) => {
	const linkPath = new URL(link.href).pathname
	if (linkPath === currentPath) {
		link.classList.add('active')
	}
})

const links2 = document.querySelectorAll('.top-navigation-bar-menu li a')
links2.forEach((link) => {
	const linkPath = new URL(link.href).pathname
	if (linkPath === currentPath) {
		link.classList.add('active')
	}
})


window.productsSlickSettings = {
	slidesToShow: 5,
	infinite: false,
	responsive: [
		{
			breakpoint: 1350,
			settings: {
				slidesToShow: 4,
			},
		},
		{
			breakpoint: 1100,
			settings: {
				slidesToShow: 3,
			},
		},
		{
			breakpoint: 830,
			settings: {
				slidesToShow: 2,
			},
		},
	],
}




function fixedHeader() {
	let scrollTop = window.pageYOffset || document.documentElement.scrollTop
	// const header2 = document.querySelector('.user-action-cart')
	// const login = document.querySelector('.user-action-login')
	const header = document.querySelector('#header')

	if (scrollTop > 45) {
		if (header) {
			header.classList.add('sticky')
		}
		// if (header2) {
		// 	header2.classList.add('sticky')
		// }
		// if (login) {
		// }
		// login.classList.add('sticky')

		// header.classList.remove('scroll-up')
		// header.classList.add('scroll-down')
	} else {
		// header.classList.remove('scroll-down')
		// header.classList.add('scroll-up')

		if (header) {
			header.classList.remove('sticky')
		}
		// if (header2) {
		// 	header2.classList.remove('sticky')
		// }
		// if (login) {
		// }
		// login.classList.remove('sticky')
	}
}

document.addEventListener('DOMContentLoaded', fixedHeader)
window.addEventListener('scroll', fixedHeader)

const moveRegistrationBannerLogin = async () => {
	if (dataLayer[0].shoptet.customer.registered === false) {
		let registrationBannerLogin = document.querySelector('.registration-banner-login')
		if (!registrationBannerLogin) {
			const storedBanner = sessionStorage.getItem('registrationBannerLogin')
			if (storedBanner) {
				const parser = new DOMParser()
				const doc = parser.parseFromString(storedBanner, 'text/html')
				registrationBannerLogin = doc.body.firstChild
			} else {
				const response = await fetch('/')
				const text = await response.text()
				const parser = new DOMParser()
				const htmlDocument = parser.parseFromString(text, 'text/html')
				registrationBannerLogin = htmlDocument.querySelector('.registration-banner-login')
				if (registrationBannerLogin) {
					sessionStorage.setItem('registrationBannerLogin', registrationBannerLogin.outerHTML)
				}
			}
		} else {
			sessionStorage.setItem('registrationBannerLogin', registrationBannerLogin.outerHTML)
		}

		// const userActionLogin = document.querySelector('.user-action-login')
		// const h2 = userActionLogin.querySelector('.popup-widget-inner h2')
		// const popUpLoginText = popUpLogin.find((item) => item.language === shoptetLang)
		// if (popUpLoginText) {
		// 	h2.innerHTML = popUpLoginText.text
		// }
		// const socialLogin = userActionLogin.querySelector('.popup-widget-inner .social-login-buttons-divider span');
		// const otherLogin = otherLogins.find(item => item.language === shoptetLang);
		// if (otherLogin) {
		// 	socialLogin.innerHTML = otherLogin.text;
		// }
		// const perex = userActionLogin.querySelector('.popup-widget-inner p')
		// if (!perex) {
		// 	const loginPerex = document.createElement('p')
		// 	const loginPerexText = loginBeneText.find((item) => item.language === shoptetLang)
		// 	if (loginPerexText) {
		// 		loginPerex.innerHTML = loginPerexText.text
		// 	}
		// 	h2.insertAdjacentElement('afterend', loginPerex)
		// 	if (registrationBannerLogin && userActionLogin) {
		// 		userActionLogin.appendChild(registrationBannerLogin)
		// 	}
		// }

		// const bgClose = userActionLogin.querySelector('.bg-close')
		// if (!bgClose) {
		// 	const bgClose2 = document.createElement('div')
		// 	bgClose2.classList.add('bg-close')
		// 	userActionLogin.appendChild(bgClose2)
		// 	bgClose2.addEventListener('click', () => {
		// 		document.body.classList.remove('login-window-visible')
		// 		document.body.classList.remove('user-action-visible')
		// 	})
		// }

		// const close = userActionLogin.querySelector('.close')
		// if (!close) {
		// 	const close2 = document.createElement('div')
		// 	close2.classList.add('close')
		// 	close2.innerHTML = '<div></div><div></div>'
		// 	userActionLogin.appendChild(close2)
		// 	close2.addEventListener('click', (event) => {
		// 		if (event.target.closest('.close')) {
		// 			document.body.classList.remove('login-window-visible')
		// 			document.body.classList.remove('user-action-visible')
		// 		}
		// 	})
		// }
	}
}

moveRegistrationBannerLogin()
document.addEventListener('ShoptetDOMPageContentLoaded', moveRegistrationBannerLogin)
document.addEventListener('ShoptetDOMContentLoaded', moveRegistrationBannerLogin)




const handleHeader = async () => {
	// const navigation = document.querySelector('#navigation');
	// if (window.innerWidth <= 767) {
	// 	const headerTop = document.querySelector('.header-top')
	// 	if (search && headerTop) {
	// 		headerTop.insertAdjacentElement('afterend', search)
	// 	}
	// }


	const searchBtn = document.querySelector('#formSearchForm button')
	if (searchBtn) {
		searchBtn.textContent = ''
	}

	const headerTopW = document.querySelector('.header-top')
	const search = document.querySelector('.header-top .search')

	const navigation = document.querySelector('#navigation')
	const menuHelper = document.querySelector('.menu-helper')
	if (menuHelper && navigation) navigation.appendChild(menuHelper)
	const navigationButtons = document.querySelector('.navigation-buttons');
	const currecyLanguage = document.querySelector('.languagesMenu');
	if (window.innerWidth >= 900) {
		if (currecyLanguage && currecyLanguage) navigationButtons.appendChild(currecyLanguage);
	} if (window.innerWidth <= 900) {

		const langTestNav = document.querySelector('#navigation .navigation-in');

		const currency = document.querySelector('.languagesMenu__box[data-target="currency"]');
		if (currency) {
			const newHelper = document.createElement('div');
			newHelper.classList.add('currency-helper');
			if (langTestNav && newHelper) langTestNav.appendChild(newHelper);


			const currencyHeader = currency.querySelector('.languagesMenu__header');
			if (currencyHeader) {
				const newCurrencyHeader = document.createElement('span');
				newCurrencyHeader.textContent = currencyHeader.textContent;
				newHelper.appendChild(newCurrencyHeader);
			}
			const allCurency = currency.querySelectorAll('.languagesMenu__list__item');
			if (allCurency.length) {
				allCurency.forEach(item => {
					const newLink = document.createElement('a');
					newLink.href = item.querySelector('a').getAttribute('href');
					newLink.textContent = item.querySelector('a').textContent;
					newHelper.appendChild(newLink);

				});
			}
		}
		const language = document.querySelector('.languagesMenu__box[data-target="language"]');
		if (language) {
			const newHelper = document.createElement('div');
			newHelper.classList.add('language-helper');
			if (langTestNav && newHelper) langTestNav.appendChild(newHelper);


			const languageHeader = language.querySelector('.languagesMenu__header');
			if (languageHeader) {
				const newLanguageHeader = document.createElement('span');
				newLanguageHeader.textContent = languageHeader.textContent;
				newHelper.appendChild(newLanguageHeader);
			}
			const allLanguages = language.querySelectorAll('li');
			if (allLanguages.length) {
				allLanguages.forEach(item => {
					const newLink = document.createElement('a');
					newLink.href = item.querySelector('a').getAttribute('href');
					newLink.textContent = item.querySelector('a').textContent;
					newHelper.appendChild(newLink);

				});
			}
		}


	}
	const loginButton = document.querySelector('.top-nav-button-account') || document.querySelector('.top-nav-button-login')
	if (navigationButtons && loginButton) navigationButtons.prepend(loginButton)

	// loginButton.textContent = '';
	const topNavigationBarMenu = document.querySelector('.top-navigation-menu')
	// const helper = document.createElement('div');
	// helper.classList.add('wrapper');
	const headerCont = document.querySelector('#header .container')
	// if (window.innerWidth >= 1100) {
	// 	if (search && navigation) {
	// 		navigation.appendChild(search)
	// 	}
	// } else {
	// 	if (search) {
	// 		headerCont.appendChild(search)
	// 	}
	// }

	if (window.innerWidth < 768) {
		const logoImg = document.querySelector(".site-name-wrapper .site-name a img");
		if (logoImg) {
			logoImg.src = "/user/documents/upload/miranda/logo-small-black.svg";
		}
		if (headerCont && search) {
			headerCont.appendChild(search)
		}
	}

	// if (!document.querySelector("body").classList.contains("ordering-process")) {
	// 	if (window.innerWidth >= 1100) {

	// 		console.log(window.innerWidth);

	// 		console.log('a');
	// 		navigation.appendChild(navigationButtons);
	// 	}
	// }
	// function logOverflowElementAndParents(el) {
	// 	console.log('Overflow element: ', el);
	// 	let parent = el.parentElement;
	// 	while (parent) {
	// 		console.log('Parent element: ', parent);
	// 		parent = parent.parentElement;
	// 	}
	// }

	// document.querySelectorAll('*').forEach((el) => {
	// 	if (el.offsetWidth > document.documentElement.offsetWidth) {
	// 		logOverflowElementAndParents(el);
	// 	}
	// });
	// helper.appendChild(navigationButtons);

	const siteHeader = document.querySelector('#header')
	const navigationIn = document.querySelector('.navigation-in');
	// if (window.innerWidth <= 900) {
	// 	const lang = document.querySelector('.languagesMenu');
	// 	if (lang && navigationIn) {
	// 		navigationIn.prepend(lang);
	// 	}
	// }
	// if (window.innerWidth >= 1100) {
	// 	if (topNavigationBarMenu && navigation) {
	// 		headerTopW.appendChild(topNavigationBarMenu)
	// 	}
	// } else {
	// 	navigationIn.appendChild(topNavigationBarMenu)
	// }


	const cartCount = document.querySelector('.cart-count');
	if (cartCount) {
		const icon = cartCount.querySelector('i');
		if (!icon) {
			const cartPrice = document.querySelector('.cart-price');
			if (cartPrice) {
				const k = kosik.find((item) => item.language === shoptetLang);
				if (k) {
					cartPrice.innerHTML = k.text;
				}
			}
		}
	}

	// if (window.innerWidth <= 1100) {
	// 	setTimeout(() => {
	// 		const allMenuLevel2 = document.querySelectorAll('.menu-level-1 li.ext');

	// 		allMenuLevel2.forEach(menuLevel2 => {
	// 			const link1 = menuLevel2.querySelector('a[data-testid="headerMenuItem"]');

	// 			const menuLevel2Helper = menuLevel2.querySelector('.menu-level-2-helper');
	// 			// console.log(link1.href);

	// 			// Create a new link
	// 			const backToggle = document.createElement('a');
	// 			backToggle.textContent = "zpět";
	// 			backToggle.classList.add('back-toggle');

	// 			// Add the new link at the beginning of menuLevel2Helper
	// 			menuLevel2Helper.insertBefore(backToggle, menuLevel2Helper.firstChild);

	// 			// Create a new link that inherits properties from link1
	// 			// const newLink = document.createElement('a');
	// 			// const oldHref = link1.href;
	// 			// newLink.href = oldHref;
	// 			// newLink.textContent = `Zobrazit vše v ${link1.innerHTML}`;
	// 			// newLink.classList = link1.classList;
	// 			// newLink.classList.add('redirect-to-orig');

	// 			// Add the new link after backToggle
	// 			// menuLevel2Helper.insertBefore(newLink, backToggle.nextSibling);

	// 			document.addEventListener('click', (e) => {
	// 				const link1 = e.target.closest('.link1');
	// 				if (link1) {
	// 					e.preventDefault();
	// 					menuLevel2.classList.add('active');
	// 				}

	// 				const backToggle = e.target.closest('.back-toggle');
	// 				if (backToggle) {
	// 					e.preventDefault();
	// 					menuLevel2Helper.classList.remove('active');
	// 				}
	// 			});

	// 		});
	// 	}, 1000);
	// }

	const searchButton = document.querySelector('.toggle-window[data-target="search"]')
	if (navigationButtons && searchButton) navigationButtons.prepend(searchButton)
	const navButtons = document.querySelector('.navigation-buttons')
	const menuTrigger = document.querySelector('.toggle-window[data-target="navigation"]')
	if (menuTrigger && navButtons) navButtons.appendChild(menuTrigger)

	if (window.innerWidth > 1100) {
		const menuLvl2s = document.querySelectorAll('#navigation .menu-level-2')
		menuLvl2s.forEach((menuLvl2) => {
			const helper = document.createElement('div')
			helper.classList.add('menu-level-2-helper')
			menuLvl2.parentElement.insertBefore(helper, menuLvl2)
			helper.appendChild(menuLvl2)
		})
	}
	// const menuLvL2Li = document.querySelectorAll('.menu-level-2 > li')
	// menuLvL2Li.forEach((li) => {
	// 	const innerImg = li.querySelector('.menu-image > img')
	// 	const toRemove = li.querySelector('.menu-image')
	// 	const targetA = li.querySelector('div > a')
	// 	if (innerImg && toRemove) {
	// 		if (innerImg.getAttribute('data-src'))
	// 			innerImg.setAttribute('data-src', innerImg.getAttribute('data-src').replace('/thumb/', '/orig/'))
	// 		if (innerImg.getAttribute('src')) innerImg.setAttribute('src', innerImg.getAttribute('src').replace('/thumb/', '/orig/'))
	// 		const imgWrap = document.createElement('div')
	// 		imgWrap.classList.add('menu-image')
	// 		imgWrap.appendChild(innerImg)
	// 		targetA.prepend(imgWrap)
	// 		toRemove.remove()
	// 	}
	// })

	const topBanner = document.querySelector('.top-panel-text-wrapper')
	const topNavigation = document.querySelector('.top-navigation-bar .container')
	if (topBanner && topNavigation) {
		topNavigation.appendChild(topBanner)
	}
	// const profeseLi =
	// 	window.innerWidth > 767
	// 		? document.querySelectorAll('.navigation-in a[href="/podle-profese/"] + .menu-level-2-helper .menu-level-3 > li')
	// 		: document.querySelectorAll('.navigation-in .menu-level-3 > li')
	// profeseLi.forEach((li) => {
	// 	const help = li.querySelector('a')
	// 	li.innerHTML = ''
	// 	li.appendChild(help)
	// })

	let initialYScroll = 0
	const debouncedScroll = debounce(function () {
		const header = document.querySelector('#header')
		const headerOffsetTop = header.offsetTop
		const windowScrollTop = window.scrollY
		// const header2 = document.querySelector('.user-action-cart')
		const login = document.querySelector('.user-action-login')
		// if (headerOffsetTop <= windowScrollTop) {
		// 	header.classList.add('sticky')
		// } else {
		// 	header.classList.remove('sticky')
		// }
		// if (window.innerWidth > 1100) {
		if (windowScrollTop > initialYScroll) {
			header.classList.remove('scroll-up')
			header.classList.add('scroll-down')
			login.classList.add('sticky');
			// header2.classList.add('sticky');
		} else {
			header.classList.remove('scroll-down')
			header.classList.add('scroll-up')
			login.classList.remove('sticky');
			// header2.classList.remove('sticky');
		}
		// }
		initialYScroll = windowScrollTop
	}, 100)

	window.addEventListener('scroll', debouncedScroll)

	const headerTop = document.querySelector('#header .header-top')
	if (headerTop) header.style.setProperty('--header-top-height', `${headerTop.clientHeight}px`)

	let liElements = document.querySelectorAll('.menu-level-3 li')

	liElements.forEach((li) => {
		let childNodes = Array.from(li.childNodes)
		childNodes.forEach((node) => {
			if (node.nodeType === 3 && node.textContent.includes(',')) {
				// 3 is a Text node
				node.textContent = node.textContent.replace(',', '')
			}
		})
	})

	// const headerBanner = document.querySelector('.custom-footer__banner1')
	// if (headerBanner) {
	// 	const allMenuLevel2Helpers = document.querySelectorAll('.menu-level-1 li.ext .menu-level-2-helper')
	// 	allMenuLevel2Helpers.forEach((helper) => {
	// 		const clone = headerBanner.cloneNode(true) // true means it will clone the node and its child nodes
	// 		helper.appendChild(clone)
	// 	})
	// }
}
handleHeader()
document.addEventListener('ShoptetDOMPageContentLoaded', handleHeader)
document.addEventListener('ShoptetDOMContentLoaded', handleHeader)
function highlightCurrentCurrency() {
	const currentCurrency = dataLayer[0].shoptet.currency
	const currencyLinks = document.querySelectorAll('.top-navigation-tools .dropdown ul li a')

	currencyLinks.forEach((link) => {
		if (link.innerHTML.trim() === currentCurrency) {
			link.classList.add('active')
		}
	})
}


document.addEventListener('click', function (event) {
	const navigation = document.querySelector('#navigation')
	if (navigation && !navigation.contains(event.target)) {
		document.body.classList.remove('navigation-window-visible', 'user-action-visible')
	}
})


highlightCurrentCurrency()
document.addEventListener('ShoptetDOMPageContentLoaded', highlightCurrentCurrency)
document.addEventListener('ShoptetDOMContentLoaded', highlightCurrentCurrency)
// const handleCarouselThumbnails = () => {
// 	const carousel = document.querySelector('#carousel')
// 	if (carousel) {
// 		const carouselItems = carousel.querySelectorAll('.item')
// 		const thumbnails = []
// 		carouselItems.forEach((item) => {
// 			const itemImage = item.querySelector('img')
// 			const itemTitle = itemImage.getAttribute('alt')
// 			const itemThumbnail = document.createElement('div')
// 			itemThumbnail.classList.add('carousel-thumbnail')
// 			itemThumbnail.innerHTML = `
// 				<img src="${itemImage.getAttribute('src') || itemImage.getAttribute('data-src')}" alt="${itemTitle}" />
// 				<span class="carousel-thumbnail-title">${itemTitle}</span>
// 			`
// 			thumbnails.push(itemThumbnail)
// 		})
// 		if (thumbnails.length > 1) {
// 			const carouselThumbnails = document.createElement('div')
// 			carouselThumbnails.classList.add('carousel-thumbnails')
// 			thumbnails.forEach((thumbnail, index) => {
// 				carouselThumbnails.appendChild(thumbnail)
// 				if (index === 0) thumbnail.classList.add('active')
// 				thumbnail.addEventListener('click', (e) => {
// 					e.preventDefault()
// 					document.querySelector('.carousel-inner .item.active').classList.remove('active')
// 					document.querySelector('.carousel-thumbnails .carousel-thumbnail.active').classList.remove('active')
// 					let targetItem = document.querySelectorAll('.carousel-inner .item')[index]
// 					const targetItemImg = targetItem.querySelector('img')
// 					if (!targetItemImg.src) targetItemImg.src = targetItemImg.getAttribute('data-src')
// 					targetItem.classList.add('active')
// 					thumbnail.classList.add('active')
// 				})
// 			})
// 			carousel.parentElement.insertBefore(carouselThumbnails, carousel.nextElementSibling)
// 		}
// 	}
// }
// handleCarouselThumbnails()

// const handleTopCategories = () => {
// 	const topCategories = document.querySelector('.top-categories')
// 	const firstProductsBlock = document.querySelector('.products-block')
// 	if (topCategories && firstProductsBlock)
// 		firstProductsBlock.parentElement.insertBefore(topCategories, firstProductsBlock.nextElementSibling)
// }
// if (shoptetPage === 'homepage') handleTopCategories()


const handleCategory = async (reload = false) => {
	const categoryTopDuplicate = document.querySelector('#content-wrapper > .category-top-wrapper')
	const categoryTop = document.querySelector('#content .category-top')
	const categoryContentWrapper = document.querySelector('#content-wrapper')
	const subcategories = document.querySelector('#content .subcategories')
	const categoryUSP = document.querySelector('.benefitBanner')
	const cats = document.querySelector('.subcategories')
	if (categoryTopDuplicate) {
		if (categoryTop) categoryTop.remove()
		if (subcategories) subcategories.remove()
		if (categoryTopDuplicate && cats) {
			categoryTopDuplicate.insertAdjacentElement('afterend', cats);
		}
	} else {
		const categoryTopContainer = document.createElement('div')
		categoryTopContainer.classList.add('category-top-wrapper')
		categoryTopContainer.appendChild(categoryTop)
		if (categoryTop) categoryContentWrapper.prepend(categoryTopContainer)

		const cats = categoryTop.querySelector('.subcategories')
		// categoryTopContainer.appendChild(title)
		// if (cats) categoryTopContainer.appendChild(cats)

		const categoryTopDuplicate2 = document.querySelector('#content-wrapper .category-top-wrapper')
		if (categoryTopDuplicate2 && cats) {
			categoryTopDuplicate2.insertAdjacentElement('afterend', cats);
		}

		// if (categoryTop && subcategories) categoryTop.appendChild(subcategories);
		// console.log(allImg)
		const imageWrapper = document.createElement('div')
		imageWrapper.classList.add('category-image')
		const categoryImage = categoryTop.querySelector('p > img') || categoryTop.querySelector('p > span > img')
		const allImg = categoryTop.querySelectorAll("p > img") || categoryTop.querySelectorAll('p > span > img');

		if (categoryImage) {
			// const toRemove = categoryImage.closest('p')
			// imageWrapper.appendChild(categoryImage);

			const windowWidth = window.innerWidth;

			allImg.forEach((img, index) => {
				// Vytvoření nové instance Image
				// console.log(index);

				if (index === 1) {
					img.style.display = "block";
				}
				const tempImg = new Image();

				tempImg.src = img.src;

				tempImg.onload = function () {
					const imgWidth = tempImg.naturalWidth;

					if ((windowWidth > 767 && imgWidth < 800) || (windowWidth <= 767 && imgWidth > 800)) {
						img.style.display = "none";
					} else {
						img.style.display = "block";
					}

					// Přidání obrázku do wrapperu po zpracování jeho rozměrů
					imageWrapper.appendChild(img);
				};
			});
			// toRemove.remove()
		} else {
			const categoryVideo = document.querySelector('p > video')
			if (categoryVideo) {
				const toRemove = categoryVideo.closest('p')
				imageWrapper.appendChild(categoryVideo)
				categoryVideo.removeAttribute('controls')
				categoryVideo.setAttribute('preload', 'auto')
				// categoryVideo.width = '454'
				// categoryVideo.height = '278'
				toRemove.remove()
				const playVideoButton = document.createElement('button')
				playVideoButton.classList.add('play-video')
				// playVideoButton.innerHTML = `<img src="https://cdn.myshoptet.com/usr/343520.myshoptet.com/user/documents/projects/worksafety/assets/img/play-video.png" alt="Přehrát video" width="167" height="124" />`
				imageWrapper.appendChild(playVideoButton)
				playVideoButton.addEventListener('click', () => {
					categoryVideo.play()
					playVideoButton.remove()
					categoryVideo.setAttribute('controls', '')
				})
			}
		}
		categoryTop.prepend(imageWrapper)
		const categoryTopBG = document.querySelector('#data-background')
		if (categoryTopBG) {
			categoryTopContainer.style.backgroundColor = categoryTopBG.getAttribute('data-background')
			categoryTopBG.remove()
		}
	}
	if (categoryTop) {
		const emptyParagraphs = categoryTop.querySelectorAll('p');
		// console.log(emptyParagraphs);
		if (emptyParagraphs.length > 0) {
			emptyParagraphs.forEach(emptyParagraph => {
				if (!emptyParagraph.textContent.trim()) {
					emptyParagraph.remove();
				}
			});
		}
	}

	// if (categoryUSP) {
	// 	const subcategoriesHelp = document.querySelector('.subcategories')
	// 	const categoryTopHelp = document.querySelector('.category-top')
	// 	if (subcategoriesHelp) {
	// 		subcategoriesHelp.parentElement.insertBefore(categoryUSP, subcategoriesHelp.nextElementSibling)
	// 	} else if (categoryTopHelp) {
	// 		categoryTopHelp.parentElement.insertBefore(categoryUSP, categoryTopHelp.nextElementSibling)
	// 	}
	// }
	// if (!reload) {
	// 	const setBackground = (desktopImg, mobileImg) => {
	// 		let desktop = desktopImg
	// 		let mobile = mobileImg
	// 		if (!desktop) desktop = mobileImg
	// 		if (!mobile) mobile = desktopImg
	// 		document.body.classList.add('has-background')
	// 		categoryTop.style.backgroundImage = window.innerWidth > 767 ? `url(${desktopImg})` : `url(${mobileImg})`
	// 	}
	// 	const categoryBG = categoryTop.querySelectorAll('p > img')
	// 	if (categoryBG.length) {
	// 		let desktopImg
	// 		let mobileImg
	// 		let imagesLoading = []
	// 		categoryBG.forEach((img) => {
	// 			console.log(img)
	// 			imagesLoading.push(
	// 				new Promise((resolve) => {
	// 					if (img.complete) {
	// 						console.log(img, img.naturalWidth)
	// 						if (img.naturalWidth > 1000) desktopImg = img.src
	// 						if (img.naturalWidth <= 1000) mobileImg = img.src
	// 						img.closest('p').remove()
	// 						resolve()
	// 					} else {
	// 						img.addEventListener('load', () => {
	// 							console.log(img, img.naturalWidth)
	// 							if (img.naturalWidth > 1000) desktopImg = img.src
	// 							if (img.naturalWidth <= 1000) mobileImg = img.src
	// 							img.closest('p').remove()
	// 							resolve()
	// 						})
	// 					}
	// 				})
	// 			)
	// 		})
	// 		console.log(imagesLoading)
	// 		Promise.all(imagesLoading)
	// 			.then(() => {
	// 				console.log(desktopImg, mobileImg)
	// 				setBackground(desktopImg, mobileImg)
	// 			})
	// 			.catch(() => {
	// 				console.log('error')
	// 			})
	// 		setTimeout(() => {
	// 			console.log(imagesLoading)
	// 		}, 1000)
	// 	} else {
	// 		document.body.classList.remove('has-background')
	// 	}
	// }
	if (subcategories) {
		const subcategoriesImages = subcategories.querySelectorAll('.image > img')
		subcategoriesImages.forEach((image) => {
			image.src = image.src.replace('/thumb/', '/orig/')
		})

		// const showCategoriesBtn = document.createElement('button')
		// showCategoriesBtn.classList.add('show-categories')
		// showCategoriesBtn.innerHTML = 'Subkategorie'
		// subcategories.prepend(showCategoriesBtn)
		// showCategoriesBtn.addEventListener('click', () => {
		// 	subcategories.classList.toggle('show')
		// })
	}
	// dlouhý (spodní) popis
	const secondDescription = document.querySelector('.category__secondDescription')
	if (secondDescription) {
		secondDescription.id = 'dlouhy-popis'
		const categoryContent = document.querySelector('#content .category-content-wrapper')
		categoryContent.parentElement.insertBefore(secondDescription, categoryContent.nextElementSibling)
	}
	// banery v kategorii
	const categoryBanners = document.querySelectorAll('.banner-category')
	const firstProductBlock = document.querySelector('#products')
	const secondProductBlock = document.querySelector('.products-block:not(#products)')
	if (secondProductBlock) {
		const secondBlockProducts = secondProductBlock.querySelectorAll('.product')
		secondBlockProducts.forEach((product) => {
			if (firstProductBlock) firstProductBlock.appendChild(product)
		})
		secondProductBlock.remove()
	}
	categoryBanners.forEach((categoryBanner, index) => {
		if (categoryBanner && firstProductBlock) {
			categoryBanner.classList.add('product')
			let whereToAppend = null
			switch (index) {
				case 0:
					categoryBanner.classList.add('first'); // Add 'first' class to the first banner
					whereToAppend = firstProductBlock.querySelector('.product:nth-child(9)')
					break
				case 1:
					categoryBanner.classList.add('second'); // Add 'second' class to the second banner
					whereToAppend = firstProductBlock.querySelector('.product:nth-child(15)')
					break
			}
			if (whereToAppend) {
				whereToAppend.after(categoryBanner)
			} else {
				firstProductBlock.appendChild(categoryBanner)
			}
		}
	})

	// const productsAnchor = document.querySelector('.category-top a[href="#products"]')
	// if (productsAnchor) {
	// 	productsAnchor.addEventListener('click', (e) => {
	// 		e.preventDefault()
	// 		e.stopPropagation()
	// 		const products = document.querySelector('#products')
	// 		products.scrollIntoView({ behavior: 'smooth' })
	// 	})
	// }
	// const dlouhyPopisAnchor = document.querySelector('.category-top a[href="#dlouhy-popis"]')
	// if (dlouhyPopisAnchor) {
	// 	dlouhyPopisAnchor.addEventListener('click', (e) => {
	// 		e.preventDefault()
	// 		e.stopPropagation()
	// 		const dlouhyPopis = document.querySelector('.category__secondDescription')
	// 		dlouhyPopis.scrollIntoView({ behavior: 'smooth' })
	// 	})
	// }

	// const unveilFilters = document.querySelector('.filters-unveil-button-wrapper')
	// if (unveilFilters && window.innerWidth <= 767) categoryTop.appendChild(unveilFilters)

	// posunutí buttonu zpět nahoru pod spodní popis
	const categoryBackTop = document.querySelector('.pagination-top')
	if (categoryBackTop) {
		const categorySecondDescription = document.querySelector('.category__secondDescription')
		if (categorySecondDescription) {
			const buttonsWrapper = document.createElement('div')
			buttonsWrapper.classList.add('buttons-wrapper', 'buttons-center')
			categorySecondDescription.appendChild(buttonsWrapper)
			buttonsWrapper.appendChild(categoryBackTop)
		}
	}




	function createSidebarWithFilters() {
		const asideActive = window.sessionStorage.getItem('asideActive') === 'true';
		console.log(asideActive);
		if (!document.querySelector('aside.sidebar.new-one')) {
			const asideElement = document.createElement('aside');
			asideElement.classList.add('sidebar', 'new-one');
			if (asideActive) {
				const allProductsExist = document.querySelectorAll('.category-content-wrapper .product');
				if (allProductsExist.length > 0) {
					asideElement.classList.add('active');
				}
			}
			const sidebarInner = document.createElement('div');
			sidebarInner.classList.add('sidebar-inner');
			asideElement.appendChild(sidebarInner);
			const filtersWrapper = document.querySelector('.filters-wrapper');
			if (filtersWrapper && sidebarInner) {
				sidebarInner.appendChild(filtersWrapper);
			}

			const contentWrapperIn = document.querySelector('.content-wrapper-in');
			const bodyElement = document.body;
			if (bodyElement.classList.contains('mobile') || window.innerWidth < 1000) {
				const close = document.createElement('div');
				close.classList.add('close', 'sidebar-close');
				sidebarInner.insertBefore(close, sidebarInner.firstChild);
				const mainContent = document.querySelector('main#content');
				if (mainContent) {
					mainContent.insertBefore(asideElement, mainContent.firstChild);
				}
				const filteringCloseBtn = document.createElement('div');
				if (filteringCloseBtn) {
					filteringCloseBtn.classList.add('btn', 'btn-primary', 'sidebar-close');
					const filteringText = filteringMobileBtnText.find((item) => item.language === shoptetLang);
					if (filteringText) {
						filteringCloseBtn.textContent = filteringText.text;
					}
					const filters = sidebarInner.querySelector('#filters .filter-sections');
					if (filters) {
						filters.appendChild(filteringCloseBtn);
					}
				}
			} else {
				if (contentWrapperIn && asideElement) {
					contentWrapperIn.insertBefore(asideElement, contentWrapperIn.firstChild);
				}
			}
			let filterSectionBoolean = document.querySelector('.filter-section-boolean');
			let categoryFilterHover = document.querySelector('#category-filter-hover');

			if (!categoryFilterHover) {
				// Vytvoření nového prvku
				categoryFilterHover = document.createElement('div');
				categoryFilterHover.id = 'category-filter-hover';

				// Najdeme prvek s třídou .filter-sections
				const filterSections = document.querySelector('.filter-sections');

				if (filterSections) {
					// Vložíme nový prvek do .filter-sections
					filterSections.appendChild(categoryFilterHover);
				} else {
					console.error('Prvek s třídou .filter-sections nebyl nalezen.');
				}
			}

			if (categoryFilterHover) {
				let filterSectionCount = categoryFilterHover.querySelector('.filter-section-count');

				if (filterSectionCount) {
					filterSectionCount.remove();
				}
			}

			setTimeout(() => {
				if (filterSectionBoolean && categoryFilterHover) {
					let forms = filterSectionBoolean.querySelectorAll('form');
					forms.forEach((form, index) => {
						let newFilterSection = document.createElement('div');
						newFilterSection.classList.add('filter-section', 'filter-section-parametric', `filter-section-parametric-id-${index}`);

						let h4 = document.createElement('h4');
						if (index === 0) {
							h4.textContent = shoptetLang === 'cs' ? 'Dostupnost' : 'Availability';
						} else if (index === 1) {
							h4.textContent = shoptetLang === 'cs' ? 'Štítky' : 'Tags';
						}
						newFilterSection.appendChild(h4);
						newFilterSection.appendChild(form);

						// Přidání nového .filter-section na konec #category-filter-hoverf
						categoryFilterHover.appendChild(newFilterSection);
					});
				}
			}, 100);
		} else if (document.querySelector('aside.sidebar.new-one')) {

			const asideElement = document.querySelector('aside.sidebar.new-one');
			if (asideActive) {
				const allProductsExist = document.querySelectorAll('.category-content-wrapper .product');
				if (allProductsExist.length > 0) {
					asideElement.classList.add('active');
				}
			}
			const sidebarInner = asideElement.querySelector('.sidebar-inner');
			asideElement.appendChild(sidebarInner);
			const filtersWrapper = document.querySelector('.filters-wrapper');
			if (filtersWrapper && sidebarInner) {
				sidebarInner.appendChild(filtersWrapper);
			}

			const contentWrapperIn = document.querySelector('.content-wrapper-in');
			const bodyElement = document.body;
			if (bodyElement.classList.contains('mobile')) {
				const mainContent = document.querySelector('main#content');
				const close = document.createElement('div');
				close.classList.add('close', 'sidebar-close');
				sidebarInner.insertBefore(close, sidebarInner.firstChild);
				if (mainContent) {
					mainContent.insertBefore(asideElement, mainContent.firstChild);
				}
				const filteringCloseBtn = document.createElement('div');
				if (filteringCloseBtn) {
					filteringCloseBtn.classList.add('btn', 'btn-primary', 'sidebar-close');
					const filteringText = filteringMobileBtnText.find((item) => item.language === shoptetLang);
					if (filteringText) {
						filteringCloseBtn.textContent = filteringText.text;
					}
					const filters = sidebarInner.querySelector('#filters .filter-sections');
					if (filters) {
						filters.appendChild(filteringCloseBtn);
					}
				}
			} else {
				if (contentWrapperIn && asideElement) {
					contentWrapperIn.insertBefore(asideElement, contentWrapperIn.firstChild);
				}
			}
			let filterSectionBoolean = document.querySelector('.filter-section-boolean');
			let categoryFilterHover = document.querySelector('#category-filter-hover');

			if (!categoryFilterHover) {
				// Vytvoření nového prvku
				categoryFilterHover = document.createElement('div');
				categoryFilterHover.id = 'category-filter-hover';

				// Najdeme prvek s třídou .filter-sections
				const filterSections = document.querySelector('.filter-sections');

				if (filterSections) {
					// Vložíme nový prvek do .filter-sections
					filterSections.appendChild(categoryFilterHover);
				} else {
					console.error('Prvek s třídou .filter-sections nebyl nalezen.');
				}
			}
			if (categoryFilterHover) {
				let filterSectionCount = categoryFilterHover.querySelector('.filter-section-count');

				if (filterSectionCount) {
					filterSectionCount.remove();
				}
			}
			// console.log(filterSectionBoolean);
			// console.log(categoryFilterHover);
			if (filterSectionBoolean && categoryFilterHover) {

				let forms = filterSectionBoolean.querySelectorAll('form');
				forms.forEach((form, index) => {
					let newFilterSection = document.createElement('div');
					newFilterSection.classList.add('filter-section', 'filter-section-parametric', `filter-section-parametric-id-${index}`);

					let h4 = document.createElement('h4');
					if (index === 0) {
						h4.textContent = shoptetLang === 'cs' ? 'Dostupnost' : 'Availability';
					} else if (index === 1) {
						h4.textContent = shoptetLang === 'cs' ? 'Štítky' : 'Tags';
					}
					newFilterSection.appendChild(h4);
					newFilterSection.appendChild(form);

					// Přidání nového .filter-section na konec #category-filter-hover
					categoryFilterHover.appendChild(newFilterSection);
				});
			}
		}
	}

	createSidebarWithFilters();
	// document.addEventListener('ShoptetDOMPageContentLoaded', createSidebarWithFilters);
	// document.addEventListener('ShoptetDOMContentLoaded', createSidebarWithFilters);
	// document.addEventListener('ShoptetPageFilterValueChange', createSidebarWithFilters);

	// const updateFilterClassDisplay = () => {
	// 	const filterSections = document.querySelectorAll('.filter-section-parametric');
	// 	const filterClass = document.querySelector('.filter-class');

	// 	if (filterClass) {
	// 		if (filterSections.length < 4) {
	// 			filterClass.style.display = 'none';
	// 		}
	// 	}
	// }

	// updateFilterClassDisplay();
	// document.addEventListener('ShoptetDOMPageContentLoaded', updateFilterClassDisplay);
	// document.addEventListener('ShoptetDOMPageContentLoaded', updateFilterClassDisplay);


	// function moveTopProducts() {
	// 	const topProducts = document.querySelector('#productsTop');
	// 	if (topProducts) {
	// 		const categoryContentMain = document.querySelector('aside.sidebar.new-one');
	// 		if (categoryContentMain) {
	// 			// Najdi nadřazený <h4>
	// 			const nearestH4 = topProducts.previousElementSibling;

	// 			categoryContentMain.insertAdjacentElement('afterend', topProducts);
	// 			if (nearestH4 && nearestH4.tagName === 'H4') {
	// 				categoryContentMain.insertAdjacentElement('afterend', nearestH4);
	// 				nearestH4.style.textAlign = 'center';
	// 				nearestH4.style.margin = '0 auto';
	// 				nearestH4.style.marginBottom = '20px';
	// 			}
	// 		}
	// 	}
	// }

	// moveTopProducts();
	// document.addEventListener('ShoptetDOMPageContentLoaded', moveTopProducts);
	// document.addEventListener('ShoptetDOMContentLoaded', moveTopProducts);

	// setTimeout(() => {
	// 	if (window.innerWidth < 900) {
	// 		const categoryContent = document.querySelector('.category-content-wrapper');

	// 		const title = categoryTop.querySelector('.category-title')
	// 		const cats = categoryTop.querySelector('.subcategories')

	// 		const div = document.createElement('div');
	// 		div.classList.add('sub-holder');

	// 		categoryContent.insertBefore(div, categoryContent.firstChild);
	// 		// categoryTopContainer.appendChild(title)
	// 		const showAllCategoriesBtn = document.createElement('div')
	// 		showAllCategoriesBtn.classList.add('show-all-categories')
	// 		showAllCategoriesBtn.textContent = 'Kategorie'

	// 		// Nastavení všech .subcategories li na display: none
	// 		const subcategoriesItem = document.querySelector('.category-top-wrapper .subcategories')
	// 		div.appendChild(showAllCategoriesBtn);
	// 		div.appendChild(cats);
	// 		showAllCategoriesBtn.addEventListener('click', function (event) {
	// 			if (event.target === showAllCategoriesBtn || showAllCategoriesBtn.contains(event.target)) {
	// 				// Přepínání třídy 'active' pro každou položku v subcategoriesItems
	// 				cats.classList.toggle('active')
	// 			}
	// 		})

	// 		// Přidání event listeneru na tlačítko
	// 	}
	// }, 1000);

	const scrollTop = document.querySelector('.pagination-top strong.js-scroll-top');
	if (scrollTop) {
		scrollTop.textContent = "Zpět nahoru";
	}

}

if (shoptetPage === "category") {
	handleCategory()
	document.addEventListener('ShoptetDOMContentLoaded', () => handleCategory(true))

	const addSubcategoryClass = () => {
		const subcategories = document.querySelector('.subcategories');
		const categoryTopWrapper = document.querySelector('.category-top-wrapper');

		if (subcategories && categoryTopWrapper) {
			categoryTopWrapper.classList.add('with-subcategory');
		}
	}

	addSubcategoryClass();
	document.addEventListener('ShoptetDOMContentLoaded', addSubcategoryClass);



	function createFilteringLink() {
		const existingFilterLink = document.querySelector('#filter');
		if (!existingFilterLink) {
			const filteringLink = document.createElement('a');
			const filterSection = document.querySelector("aside #filters .filter-sections");
			if (filterSection) {
				let filterText = filterBtnText.find(item => item.language === shoptetLang);
				if (window.innerWidth < 1001) {
					filterText = filterBtnText.find(item => item.language === shoptetLang);
				} else {
					filterText = filterBtnText.find(item => item.language === shoptetLang);
				}
				if (filterText) {
					if (window.innerWidth < 1001) {
						filteringLink.innerHTML = filterText.text;
					} else {
						filteringLink.innerHTML = filterText.text;
					}

					if (window.innerWidth < 1001) {
						filteringLink.classList.add("filtering-btn", "filter-class");
					} else {
						filteringLink.classList.add("filtering-btn", "btn", "btn-primary", "filter-class");
					}
					filterSection.appendChild(filteringLink);
					filteringLink.id = "filter";

					const contentWrapper = document.querySelector('.content-wrapper-in');
					if (window.innerWidth < 1000 && document.body.classList.contains('mobile')) {
						const btnHolderDiv = document.createElement('div');
						btnHolderDiv.classList.add('btn-holder-filter');
						contentWrapper.insertBefore(btnHolderDiv, contentWrapper.firstChild);
						btnHolderDiv.appendChild(filteringLink);

					} else {
						filterSection.appendChild(filteringLink);

					}
				}
			}
		}
		const subcategoriesContent = document.querySelector('.subcategories');
		const realBtnExist = document.querySelector('.filtering-btn.no-before');
		const filteringHolder = document.querySelector('.btn-holder-filter');
		if (filteringHolder && !realBtnExist && subcategoriesContent) {
			const subcategoriesBtn = document.createElement('a');
			const subcategoriesText = subcategoriesBtnCategory.find(item => item.language === shoptetLang);
			if (subcategoriesText) {
				subcategoriesBtn.innerHTML = subcategoriesText.text;
			}
			subcategoriesBtn.classList.add('filtering-btn', 'no-before');
			// btnHolderDiv.insertBefore(subcategoriesBtn, btnHolderDiv.firstChild);
			filteringHolder.appendChild(subcategoriesBtn);
			// Přidání posluchače událostí pro toggle třídy active
			subcategoriesBtn.addEventListener('click', function () {
				const subcategories = document.querySelector('.subcategories');
				if (subcategories) {
					subcategories.classList.toggle('active');
				}
			});
		}
	}

	createFilteringLink();
	document.addEventListener('ShoptetDOMPageContentLoaded', createFilteringLink);
	document.addEventListener('ShoptetDOMContentLoaded', createFilteringLink);
	document.addEventListener('ShoptetPageSortingChanged', createFilteringLink);
	window.addEventListener('resize', createFilteringLink);


	document.body.addEventListener('click', (event) => {
		if (event.target.matches('.filter-class')) {
			event.stopPropagation();
			event.stopImmediatePropagation();

			const filterButton = event.target;
			if (!filterButton.classList.contains('active')) {
				filterButton.classList.add('active');

				if (window.innerWidth > 1000) {
					filterButton.innerHTML = filterBtnTextClose.find(item => item.language === shoptetLang)?.text;
				}

				const filterSections = document.querySelectorAll('#category-filter-hover');
				const asideElement = document.querySelector('.type-category aside.sidebar');

				asideElement.classList.add('active');
				filterSections.forEach(section => {
					section.classList.add('active');
				});

				window.sessionStorage.setItem('filterActive', 'true');
				window.sessionStorage.setItem('asideActive', 'true'); // Uložit stav aside
			} else {
				filterButton.classList.remove('active');

				if (window.innerWidth > 1000) {
					filterButton.innerText = filterBtnText.find(item => item.language === shoptetLang)?.text;
				}

				const filterSections = document.querySelectorAll('#category-filter-hover');
				const asideElement = document.querySelector('.type-category aside.sidebar');

				asideElement.classList.remove('active');
				filterSections.forEach(section => {
					section.classList.remove('active');
				});

				window.sessionStorage.setItem('filterActive', 'false');
				window.sessionStorage.setItem('asideActive', 'false'); // Uložit stav aside
			}
		}
	});

	function restoreFilterState() {
		const filterActive = window.sessionStorage.getItem('filterActive');
		const asideActive = window.sessionStorage.getItem('asideActive') === 'true';

		if (filterActive === 'true') {
			const filterButton = document.querySelector('.filter-class');
			if (filterButton) {
				filterButton.classList.add('active');

				if (window.innerWidth > 1000) {
					filterButton.innerHTML = filterBtnTextClose.find(item => item.language === shoptetLang)?.text;
				}
				const filterSections = document.querySelectorAll('#category-filter-hover');
				filterSections.forEach(section => {
					section.classList.add('active');
				});
			}
		}

		// Pozorovatel změn v DOM pro element aside
		const observer = new MutationObserver((mutationsList, observer) => {
			for (let mutation of mutationsList) {
				if (mutation.type === 'childList') {
					const asideElement = document.querySelector('.type-category aside.sidebar');
					if (asideElement) {
						if (window.innerWidth < 1000 && asideActive) {
							asideElement.classList.add('active');
						}
						// Odpojit pozorovatele po nalezení elementu aside
						observer.disconnect();
					}
				}
			}
		});

		// Konfigurace pozorovatele
		const config = { childList: true, subtree: true };

		// Spustit pozorovatele na kořenovém elementu
		observer.observe(document.body, config);
	}

	function saveAsideState() {
		const asideElement = document.querySelector('.type-category aside.sidebar');
		if (asideElement) {
			window.sessionStorage.setItem('asideActive', asideElement.classList.contains('active'));
		}
		console.log(asideActive);
	}

	document.addEventListener('ShoptetDOMPageContentLoaded', restoreFilterState);
	document.addEventListener('DOMContentLoaded', saveAsideState);
	document.addEventListener('click', saveAsideState); // Save state on click events to capture changes

	function closeSidebar() {
		const asideElement = document.querySelector('.type-category aside.sidebar');
		if (asideElement) {
			asideElement.classList.remove('active');
		}
	}

	// Přidání posluchače událostí pomocí funkce on
	on('click', '.sidebar-close', closeSidebar);

	// Volání funkce closeSidebar při načtení stránky nebo po nějaké události
	document.addEventListener('DOMContentLoaded', closeSidebar);
	document.addEventListener('ShoptetDOMPageContentLoaded', closeSidebar);


	// const handleCheckedFilters = () => {
	// 	const activeFilters = document.querySelectorAll('#filters input[type="checkbox"]:checked+label');
	// 	const categoryContent = document.querySelector('.content-wrapper-in');

	// 	const existingActiveFilters = categoryContent.querySelector('.active-filters');
	// 	if (existingActiveFilters) existingActiveFilters.remove();

	// 	if (activeFilters.length && categoryContent) {
	// 		let activeFiltersWrapper = document.createElement('div');
	// 		let activeFiltersList = document.createElement('div');

	// 		activeFiltersWrapper.classList.add('active-filters');
	// 		activeFiltersList.classList.add('active-list');

	// 		activeFiltersWrapper.appendChild(activeFiltersList);

	// 		activeFilters.forEach((item) => {
	// 			activeFiltersList.appendChild(item.cloneNode(true));
	// 		});

	// 		let deleteFilters = document.querySelector('#clear-filters');
	// 		if (deleteFilters) activeFiltersWrapper.appendChild(deleteFilters);

	// 		categoryContent.appendChild(activeFiltersWrapper);
	// 	}
	// }

	// handleCheckedFilters();
	// document.addEventListener('ShoptetDOMContentLoaded', handleCheckedFilters);



	const setFilterSectionsZIndex = async () => {
		const filterSections = document.querySelectorAll('.filter-section');
		// console.log(filterSections);
		if (filterSections.length > 0) {
			filterSections.forEach((section, index) => {
				section.style.zIndex = 20 - index;
			});
		}
	}

	setTimeout(() => {
		setFilterSectionsZIndex();
		document.addEventListener('ShoptetDOMContentLoaded', setFilterSectionsZIndex);
		document.addEventListener('ShoptetDOMPageContentLoaded', setFilterSectionsZIndex);
	}, 100);
}
const handleFilterEvents = () => {
	const bindFilterEvents = () => {
		const filterSections = document.querySelectorAll('.filter-section');
		if (filterSections.length) {
			filterSections.forEach((section) => {
				let heading = section.querySelector('h4');
				if (heading && !heading.dataset.clickBound) {  // Check if the event is already bound
					heading.dataset.clickBound = true;  // Mark that the click event is bound
					heading.addEventListener('click', (e) => {
						console.log("yes")
						e.preventDefault();
						e.stopPropagation();
						section.classList.toggle('filter-form-visible');
						let cache = JSON.parse(window.sessionStorage.getItem('openedFilters')) || [],
							parentClass = e.currentTarget.parentElement.className;
						parentClass = parentClass.replace('filter-form-visible', '').trim();
						if (cache.includes(parentClass)) {
							cache = cache.filter((item) => item !== parentClass);
						} else {
							cache.push(parentClass);
						}
						window.sessionStorage.setItem('openedFilters', JSON.stringify(cache));
					});
				}
			});
		}

		let helperCache = window.sessionStorage.getItem('openedFilters');
		if (helperCache && helperCache.length) {
			helperCache = JSON.parse(helperCache);
			helperCache.forEach((item) => {
				item = item.replaceAll(' ', '.');
				item = document.querySelector(`.${item}`);
				if (item && !item.classList.contains('filter-form-visible')) {
					item.classList.add('filter-form-visible');
				}
			});
		}
	};

	// Initial binding
	bindFilterEvents();

	// Use MutationObserver to watch for changes in the DOM
	const observer = new MutationObserver((mutationsList) => {
		for (const mutation of mutationsList) {
			if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
				bindFilterEvents();
			}
		}
	});

	observer.observe(document.body, { childList: true, subtree: true });
};

// Call the function to initialize
handleFilterEvents();

if (shoptetPage === 'category') {
	handleFilterEvents();
	document.addEventListener('ShoptetDOMContentLoaded', handleFilterEvents);
}
document.addEventListener('click', (event) => {
	const filterSections = document.querySelectorAll('.filter-section');
	if (!event.target.closest('.filter-section')) {
		filterSections.forEach((section) => {
			section.classList.remove('filter-form-visible');
		});
	}
});
const handleProductDetail = async () => {
	const pInnerHeader = document.querySelector('.p-detail-inner-header')
	const pDetailInfo = document.querySelector('.p-detail-info')
	const pInfoWrapper = document.querySelector('.p-info-wrapper')
	const pImage = document.querySelector('.p-image-wrapper .p-image')
	const flagsDefault = document.querySelector('.p-detail .flags-default')
	const flagsExtra = document.querySelector('.p-detail .flags-extra')


	const pCodeLabel = document.querySelector('.p-code .p-code-label')
	if (pCodeLabel) {
		pCodeLabel.innerHTML = codeText.find(item => item.language === shoptetLang)?.text;
	}

	if (flagsDefault && flagsExtra) {
		flagsDefault.appendChild(flagsExtra)
		flagsDefault.classList.add('contains-extra')
	}
	// if (flagsDefault) {
	// 	pImage.appendChild(flagsDefault)
	// }
	// if (flagsExtra && !flagsDefault) {
	// 	pImage.appendChild(flagsExtra)
	// }
	const addToCartBtn = pInfoWrapper.querySelector('.add-to-cart-button')
	if (addToCartBtn) {
		addToCartBtn.innerHTML = productDetailAddBtn.find((item) => item.language === shoptetLang)?.text
	}

	// const favoutites = pDetailInfo.querySelector('#dkLabFavouriteDiv .dkLabFavDetailSpan');
	// console.log(favoutites)
	// if (favoutites) {
	// 	const span = favoutites.querySelector('.dkLabFavDetailSpan');
	// 	const text = favoutites.querySelector('span');
	// 	text.innerHTML = productDetailFavourite.find(item => item.language === shoptetLang)?.text;
	// 	if (span.classList.contains('dkLabFavouriteDetailLinkRemove')) {
	// 		text.innerHTML = productDetailFavourite.find(item => item.language === shoptetLang)?.remove;
	// 	}
	// }
	const targetNode = document.body

	if (targetNode) {
		const config = { childList: true, subtree: true }

		const callback = function (mutationsList, observer) {
			for (let mutation of mutationsList) {
				if (mutation.type === 'childList') {
					const favourites = document.querySelector('#dkLabFavouriteDiv .dkLabFavDetailSpan')
					if (favourites) {
						// Disconnect the observer before making changes in the DOM
						observer.disconnect()

						const text = favourites.querySelector('span')
						text.innerHTML = productDetailFavourite.find((item) => item.language === shoptetLang)?.text
						if (favourites.classList.contains('dkLabFavouriteDetailLinkRemove')) {
							text.innerHTML = productDetailFavourite.find((item) => item.language === shoptetLang)?.remove
						}

						// Find .social-buttons-wrapper and move #dkLabFavouriteDiv into it
						const socialButtonsWrapper = document.querySelector('.social-buttons-wrapper .link-icons')
						const dkLabFavouriteDiv = document.querySelector('#dkLabFavouriteDiv')
						if (socialButtonsWrapper && dkLabFavouriteDiv) {
							socialButtonsWrapper.appendChild(dkLabFavouriteDiv)
						}

						// Reconnect the observer after making changes in the DOM
						observer.observe(targetNode, config)
					}
				}
			}
		}

		const observer = new MutationObserver(callback)
		observer.observe(targetNode, config)
	}


	// if (flagsDefault && pImage) pImage.appendChild(flagsDefault)
	if (pInnerHeader && pDetailInfo) pInnerHeader.appendChild(pDetailInfo)
	if (pInfoWrapper && pInnerHeader) pInfoWrapper.prepend(pInnerHeader)

	// const pThumbnails = document.querySelector('.p-thumbnails')
	// if (pThumbnails) {
	// 	const thumbnailsTrack = pThumbnails.querySelector('.p-thumbnails-inner > div')
	// 	setTimeout(() => {
	// 		if (thumbnailsTrack && pThumbnails.clientWidth < thumbnailsTrack.clientWidth) {
	// 			pThumbnails.classList.add('overflow-next')
	// 		}
	// 	}, 500)
	// }

	const customAddToCart = document.createElement('div')
	customAddToCart.classList.add('add-to-cart-wrapper')
	const productPrices = document.querySelector('.p-final-price-wrapper')
	if (productPrices) customAddToCart.appendChild(productPrices)

	// console.log("yes");

	const pCode = document.querySelector('.p-info-wrapper .p-code')
	const availability = document.querySelector('.product-top .availability-value')
	const pHeader = document.querySelector('.p-detail-inner-header')
	const pInfo = document.querySelector('.p-info-wrapper')
	if (availability) {
		const label = document.createElement('span');
		label.classList.add('availability-label-first');
		label.innerHTML = availabilityTitle.find(item => item.language === shoptetLang)?.text + ":";
		availability.prepend(label);
		pInfo.appendChild(availability);
	}
	const mark = pHeader.querySelector('.p-detail-info')
	if (mark) {
		const divElement = mark.querySelector('div:not([class])') // select div without a class
		if (divElement) {
			const linkElement = divElement.querySelector('a')
			const textNode = divElement.childNodes[0]

			const spanElement = document.createElement('span')
			spanElement.className = 'brand-label'
			spanElement.textContent = textNode.textContent.trim()

			// Remove the original text node
			divElement.removeChild(textNode)

			// Insert the new span element at the beginning of the div
			divElement.insertBefore(spanElement, divElement.firstChild)
		}
	}

	const saleNumber = document.querySelector('.price-standard')
	const finalNumber = document.querySelector('.price-final .price-final-holder')

	// if (saleNumber && finalNumber) {
	// 	const saleFinal = parseFloat(finalNumber.textContent) - parseFloat(saleNumber.textContent);
	// 	const salePercent = document.querySelector('.price-save .default-variant') || document.querySelector('.price-save');

	// 	const div = document.createElement('div');
	// 	div.classList.add('price-sale');
	// 	const span = document.createElement('span');
	// 	const span1 = document.createElement('span');
	// 	div.appendChild(span);
	// 	div.appendChild(span1);
	// 	span1.classList.add('saved-price-holder');
	// 	span.innerHTML = productDetailSale.find(item => item.language === shoptetLang)?.text;
	// 	// const currencyArray = [
	// 	// 	{ currencyID: 'CZK', currencyText: 'Kč' },
	// 	// 	{ currencyID: 'EUR', currencyText: '€' },
	// 	// 	{ currencyID: 'USD', currencyText: '$' },
	// 	// ];

	// 	// const currency = dataLayer[0].shoptet.currency;
	// 	// const displayCurrency = currencyArray.find(item => item.currencyID === currency)?.currencyText;
	// 	// if (displayCurrency) {

	// 	span1.innerHTML = `${salePercent.textContent}`;
	// 	// }
	// 	pHeader.appendChild(div);
	// }

	// const finalPrice = document.querySelector('.price-final');
	// if (finalPrice) {
	// 	const div = document.createElement('div');
	// 	div.classList.add('final-price');
	// 	const span = document.createElement('span');
	// 	span.classList.add('final-price-label');
	// 	div.appendChild(span);
	// 	div.appendChild(finalPrice);
	// 	span.innerHTML = productDetailPriceText.find(item => item.language === shoptetLang)?.text;
	// 	pHeader.appendChild(div);
	// }

	const productQuantity = document.querySelector('.add-to-cart .quantity')
	if (productQuantity) customAddToCart.appendChild(productQuantity)
	const addToCart = document.querySelector('.add-to-cart')
	if (addToCart) customAddToCart.appendChild(addToCart)
	pInfoWrapper.appendChild(customAddToCart)
	const availabilityValue = document.querySelector('.product-top .availability-value')
	const shippingOptions = document.querySelector('.product-top .shipping-options')
	const timeDel = document.querySelector('.delivery-time-label')
	// const th = timeDel.closest('th');
	// th.classList.add('delivery-time-holder')
	// console.log(availabilityValue, shippingOptions)
	if (availabilityValue && shippingOptions) availabilityValue.appendChild(shippingOptions);
	// if (th && shippingOptions) th.appendChild(shippingOptions)
	// const priceStandart = document.querySelector('.price-standard');
	// const pricesHolder = customAddToCart.querySelector(".p-final-price-wrapper");
	// if (priceStandart && pricesHolder) pricesHolder.appendChild(priceStandart)
	// konkurenční výhody přesunuté pod tabs
	// const detailUSP = document.querySelector('.benefitBanner')
	// if (detailUSP) {
	// 	const detailContent = document.querySelector('#content')
	// 	const uspContainer = document.createElement('div')
	// 	uspContainer.classList.add('usp-container')
	// 	const uspContainerInner = document.createElement('div')
	// 	uspContainerInner.classList.add('container')
	// 	uspContainerInner.appendChild(detailUSP)
	// 	uspContainer.appendChild(uspContainerInner)
	// 	detailContent.appendChild(uspContainer)
	// }

	// const linkIcon = document.querySelector('.social-buttons-wrapper .link-icon.chat');
	// if (linkIcon) {
	// 	const addToCart = document.querySelector('.product-top .add-to-cart-wrapper');
	// 	linkIcon.innerHTML = askUsText.find(item => item.language === shoptetLang)?.text;
	// 	addToCart.appendChild(linkIcon);
	// };

	if (window.innerWidth <= 767) {
		let wrapRemoved = false

		const handleWrap = () => {
			if (!wrapRemoved) {
				const wrap = document.querySelector('#wrap')
				if (wrap) {
					const link = wrap.querySelector('a')
					if (link) {
						wrap.parentNode.insertBefore(link, wrap)
					}
					wrap.parentNode.removeChild(wrap)
					wrapRemoved = true

					clearInterval(checkInterval)
				}
			}
		}

		const checkInterval = setInterval(handleWrap, 500)

		const thumbnails = document.querySelectorAll('.p-thumbnail')

		// thumbnails na mobilu přetvořené na obrázky vedle sebe se sliderem
		if (thumbnails.length) {
			let mainImage = document.querySelector('.p-image > .p-main-image'),
				productImage = document.querySelector('.product-top .p-image-wrapper'),
				sliderWrapper = document.createElement('div')

			sliderWrapper.classList.add('custom-slider-wrapper')
			sliderWrapper.appendChild(mainImage)

			thumbnails.forEach((thumb, index) => {
				if (index > 0) {
					let imgUrl = thumb.getAttribute('href'),
						aEl = document.createElement('a'),
						imgEl = document.createElement('img')
					aEl.classList.add('p-main-image')
					aEl.href = imgUrl
					aEl.appendChild(imgEl)
					imgEl.src = imgUrl
					sliderWrapper.appendChild(aEl)
				}
			})

			productImage.querySelector('.p-image').appendChild(sliderWrapper)
			// console.log(sliderWrapper);

			// $(sliderWrapper).slick({
			// 	infinite: false,
			// 	arrows: false,
			// 	slidesToShow: 1.2,
			// 	slidesToScroll: 1,
			// 	dots: true,
			// })

			// swiperize({
			// 	containers: sliderWrapper,
			// 	slide: '.p-main-image',
			// 	customOptions: {
			// 		fullscreen: false,
			// 		infinity: false,
			// 		dots: true,
			// 		arrows: false,
			// 		scrollbar: false,
			// 		lazyPrevNext: true
			// 	},
			// 	swiperOptions: {
			// 		direction: 'horizontal',
			// 		speed: 800,
			// 		spaceBetween: 12,
			// 		slidesPerView: 1.2,

			// 	},
			// });
		}

		// let flags = document.querySelector('.p-info-wrapper .flags')
		// let imageWrapper = document.querySelector('.p-image-wrapper')
		// if (imageWrapper && flags) {
		// 	imageWrapper.before(flags)
		// }


	}
	const pDetailInnerHeader = document.querySelector(".p-info-wrapper")
	const productBanner = document.querySelector('.product-detail-contact')
	if (productBanner) {

		if (pDetailInnerHeader) pDetailInnerHeader.appendChild(productBanner)

		const linkIconChat = document.querySelector('.social-buttons-wrapper .link-icon.chat');
		if (linkIconChat) {
			const link = linkIconChat.href;
			const btn = document.querySelector('.product-detail-contact .btn.chat.link-icon');
			if (btn && link) {
				btn.href = link;
			}
		}
	}

	const preowned = pDetailInnerHeader.querySelector('.flag-preowned')
	const unworn = pDetailInnerHeader.querySelector('.flag-unworn')
	const yearFlags = Array.from(pDetailInnerHeader.querySelectorAll('.flag')).filter(flag => {
		return /\bflag-\d{4}\b/.test(flag.className);
	});
	const pBottom = document.querySelector('.p-info-wrapper');

	const specialHolder = document.createElement('div');
	specialHolder.classList.add('special-holder');
	if (specialHolder && pBottom) {
		pBottom.appendChild(specialHolder);
		if (preowned) specialHolder.appendChild(preowned);
		if (unworn) specialHolder.appendChild(unworn);
		if (yearFlags.length) yearFlags.forEach(flag => specialHolder.appendChild(flag));
	}



}
if (shoptetPage === 'productDetail') {
	handleProductDetail()
}



const handlePost = async () => {
	const postHeaderWrapper = document.createElement('div')
	postHeaderWrapper.classList.add('post-header-wrapper')
	const postHeader = document.createElement('div')
	postHeader.classList.add('columns', 'col-2', 'align-center', 'container')
	postHeaderWrapper.appendChild(postHeader)
	const postHeaderTexts = document.createElement('div')
	postHeaderTexts.classList.add('post-header-texts', 'column')
	const postHeaderImage = document.createElement('div')
	postHeaderImage.classList.add('post-header-image', 'column')
	postHeader.appendChild(postHeaderTexts)
	postHeader.appendChild(postHeaderImage)
	const postDate = document.querySelector('.news-item-detail meta[itemprop="datePublished"]')
	if (postDate) {
		const postDateEl = document.createElement('div')
		postDateEl.classList.add('post-date')
		postDateEl.innerHTML = new Date(postDate.getAttribute('content')).toLocaleString('cs-CZ', {
			year: 'numeric',
			month: 'numeric',
			day: 'numeric',
		})
		postHeaderTexts.appendChild(postDateEl)
	}
	const postTitle = document.querySelector('.news-item-detail h1[itemprop="headline"]')
	if (postTitle) postHeaderTexts.appendChild(postTitle)
	const postDescriptionContent = document.querySelector('.news-item-detail meta[itemprop="description"]')
	if (postDescriptionContent) {
		const postDescription = document.createElement('p')
		postDescription.classList.add('post-description')
		postDescription.innerHTML = postDescriptionContent.getAttribute('content')
		postHeaderTexts.appendChild(postDescription)
	}
	const contentWrapper = document.querySelector('#content-wrapper')
	contentWrapper.parentElement.insertBefore(postHeaderWrapper, contentWrapper)

	const postImageURL = document.querySelector('.news-item-detail span[itemprop="image"] meta[itemprop="url"]')
	const postImageWidth = document.querySelector('.news-item-detail span[itemprop="image"] meta[itemprop="width"]')
	const postImageHeight = document.querySelector('.news-item-detail span[itemprop="image"] meta[itemprop="height"]')
	if (postImageURL) {
		const postImage = document.createElement('img')
		postImage.src = postImageURL.getAttribute('content')
		postImage.width = postImageWidth.getAttribute('content')
		postImage.height = postImageHeight.getAttribute('content')
		postHeaderImage.appendChild(postImage)
	}
	// else {
	// 	const urlArray = []
	// 	urlArray.push(window.location.pathname.replaceAll('/blog/', '').replaceAll('/archiv/', '').replaceAll('/', ''))
	// 	const imageData = await fetchBlogImages(urlArray)
	// 	if (imageData) {
	// 		imageData.forEach((img) => {
	// 			if (window.location.pathname.includes(img.url)) {
	// 				const postImage = document.createElement('img')
	// 				postImage.src = img.image
	// 				postHeaderImage.appendChild(postImage)
	// 			}
	// 		})
	// 	}
	// }

	// vytvoří sidebar v blogu a fetchne tam podrubriky
	const postSidebar = document.createElement('div')
	postSidebar.classList.add('type-posts-listing', 'blog-title-holder')
	const postContent = document.querySelector('#content')
	const header = document.querySelector('.post-header-wrapper')

	// const blogTitle2 = document.createElement('h4');
	// postSidebar.appendChild(blogTitle2);
	// const blogNadpis = blogTitle.find(item => item.language === shoptetLang);
	// if (blogNadpis) {
	// 	blogTitle2.innerHTML = blogNadpis.text;
	// }

	// if (header) {
	// 	header.insertAdjacentElement('beforebegin', postSidebar);
	// }
}
if (document.body.classList.contains('type-post')) handlePost()

function getScrollbarWidth() {
	const div = document.createElement('div')
	div.style.overflowY = 'scroll'
	div.style.width = '50px'
	div.style.height = '50px'
	div.style.visibility = 'hidden'
	document.body.appendChild(div)
	const scrollbarWidth = div.offsetWidth - div.clientWidth
	document.body.removeChild(div)
	return scrollbarWidth
}

document.documentElement.style.setProperty('--scrollbar-width', `${getScrollbarWidth()}px`)

// const addCartTitle = () => {
// 	const cartWrapper = document.querySelector("#cart-wrapper");
// 	if (cartWrapper) {
// 		const cartTable = cartWrapper.querySelector(".col-md-8 .cart-content .cart-table tbody");
// 		if (cartTable) {
// 			if (!cartTable.parentNode.querySelector('h2')) {
// 				const cartTitle = document.createElement("h2");
// 				const cartTitleText = cartTitleTexts.find(item => item.language === shoptetLang);
// 				if (cartTitleText) {
// 					cartTitle.innerHTML = cartTitleText.text;
// 				}
// 				cartTable.parentNode.insertBefore(cartTitle, cartTable);
// 			}
// 		}
// 	}
// };

// addCartTitle();
// document.addEventListener('ShoptetDOMCartContentLoaded', addCartTitle);
// document.addEventListener('ShoptetDOMContentLoaded', addCartTitle);
// document.addEventListener('ShoptetDOMCartCountUpdated', addCartTitle);
// document.addEventListener('ShoptetCartUpdated', addCartTitle);

const allProducts = document.querySelectorAll('.product')
if (allProducts.length) {
	allProducts.forEach((product) => {
		const productWidgets = product.querySelectorAll('.widget-parameter-wrapper .widget-parameter-list .widget-parameter-value')

		if (productWidgets.length > 0) {
			productWidgets.forEach((widget, index) => {
				if (index >= 3) {
					widget.style.display = 'none'
				}
			})
		}
	})
}
const footer = document.querySelector('#footer .custom-footer')
// if (footer) {
// 	const oldSiteName = document.querySelector('#footer .site-name')
// 	const elements7BannerWrapper = footer.querySelector('.custom-footer .custom-footer__banner9 .banner-wrapper')

// 	// If the old site name exists, remove it
// 	// if (oldSiteName) {
// 	// 	oldSiteName.remove()
// 	// }

// 	// If elements7BannerWrapper exists, create and insert the new site name element before it
// 	if (elements7BannerWrapper) {
// 		const newSiteNameHTML = `<div class="site-name"><a href="/" data-testid="linkWebsiteLogo"><img src="/user/documents/upload/logo-white.svg" alt="SPECTRUM CZ s.r.o."></a></div>`
// 		// Convert the HTML string into a document fragment
// 		const range = document.createRange()
// 		const documentFragment = range.createContextualFragment(newSiteNameHTML)
// 		elements7BannerWrapper.parentNode.insertBefore(documentFragment, elements7BannerWrapper)
// 	}
// }

const sliderWrapper = document.querySelector('.slider-wrapper')
if (sliderWrapper) {
	const content = sliderWrapper.querySelector('.slider-content')
	const header = sliderWrapper.querySelector('.slider-header .from')
	header.insertAdjacentElement('afterend', content)
}
function rearrangeSliderContent() {
	const sliderWrapper = document.querySelector('.slider-wrapper')
	if (sliderWrapper) {
		const content = sliderWrapper.querySelector('.slider-content')
		const header = sliderWrapper.querySelector('.slider-header .from')
		if (header && content) {
			header.insertAdjacentElement('afterend', content)
		}
	}
}
rearrangeSliderContent()
document.addEventListener('ShoptetDOMPageContentLoaded', rearrangeSliderContent)
document.addEventListener('ShoptetDOMContentLoaded', rearrangeSliderContent)


// if (shoptetPage === "productDetail") {
// 	function variantsHandler(id) {
// 		$(function () {
// 			if ($(`.variant-list select.parameter-id-${id}`).length) {
// 				$(`.variant-list select.parameter-id-${id}`).each(function (
// 					option_index
// 				) {
// 					so_classes = $(this).attr("class");
// 					so_value = $(this).html();
// 					so_attr1 = $(this).attr("data-parameter-id");
// 					so_attr2 = $(this).attr("data-parameter-name");
// 					so_attr3 = $(this).attr("id");
// 					so_attr4 = $(this).attr("name");
// 					so_newLabel = $("<div></div>").html(so_value);
// 					$(so_newLabel).attr("class", so_classes);
// 					$(so_newLabel).attr("data-parameter-id", so_attr1);
// 					$(so_newLabel).attr("data-parameter-name", so_attr2);
// 					$(so_newLabel).attr("id", so_attr3);
// 					$(so_newLabel).attr("name", so_attr4);
// 					$(so_newLabel).attr("value", option_index);

// 					$(this).replaceWith(so_newLabel);
// 				});
// 				if (
// 					$(`.variant-list:first-of-type .parameter-id-${id} option`).length == 1
// 				) {
// 					$(`.variant-list:first-of-type .parameter-id-${id}`).prepend(
// 						"<option></option>"
// 					);
// 				}
// 				if (
// 					$(`.variant-list:nth-of-type(2) .parameter-id-${id} option`).length ==
// 					1
// 				) {
// 					$(`.variant-list:nth-of-type(2) .parameter-id-${id}`).prepend(
// 						"<option></option>"
// 					);
// 				}
// 				if (
// 					$(`.variant-list:nth-of-type(3) .parameter-id-${id} option`).length ==
// 					1
// 				) {
// 					$(`.variant-list:nth-of-type(3) .parameter-id-${id}`).prepend(
// 						"<option></option>"
// 					);
// 				}
// 				$(`.variant-list .parameter-id-${id} option:first-of-type`).wrap(
// 					"<span></span>"
// 				);
// 				$(
// 					`.variant-list:first-of-type .parameter-id-${id} span option`
// 				).replaceWith(
// 					'<input type="radio" value name class="variant-default" checked="checked">'
// 				);
// 				$(
// 					`.variant-list:nth-of-type(2) .parameter-id-${id} span option`
// 				).replaceWith(
// 					'<input type="radio" value name class="variant-default" checked="checked">'
// 				);
// 				$(
// 					`.variant-list:nth-of-type(3) .parameter-id-${id} span option`
// 				).replaceWith(
// 					'<input type="radio" value name class="variant-default" checked="checked">'
// 				);
// 				$(`.variant-list .parameter-id-${id} option:not(:first-child)`).wrap(
// 					"<label class='advanced-parameter'></label>"
// 				);
// 				$(`.variant-list .parameter-id-${id} label option`).each(function (
// 					data_index
// 				) {
// 					option_value = $(this).attr("value");
// 					option_html = $(this).html();
// 					option_select = $(this).attr("selected");
// 					option_name = $(this).parents(`.parameter-id-${id}`).attr("name");
// 					option_newLabel = $("<input>");
// 					option_newInDiv = $("<span class='parameter-value'></span>").html(
// 						option_html
// 					);
// 					option_newBeDiv = $(
// 						'<span class="advanced-parameter-inner show-tooltip" title=""></span>'
// 					);
// 					option_newApSpan = $('<span class="pkVS"></span>').html(option_html);
// 					option_data_index = data_index + 1;
// 					$(option_newLabel).attr("value", option_value);
// 					$(option_newLabel).attr("name", option_name);
// 					$(option_newLabel).attr("selected", option_select);
// 					$(option_newLabel).attr("data-index", option_data_index);
// 					$(option_newLabel).attr("type", "radio");

// 					$(this)
// 						.parents(".hidden-split-parameter")
// 						.children("span")
// 						.children("input")
// 						.attr("name", option_name);
// 					$(this).after(option_newInDiv);
// 					$(this).before(option_newBeDiv);
// 					$(this)
// 						.parent("label")
// 						.find(".advanced-parameter-inner")
// 						.append(option_newApSpan);
// 					$(this).replaceWith(option_newLabel);

// 					let dataCodeHelper = `${so_attr1}-${option_value}`;

// 					const c = $(document).find(".p-code .parameter-dependent");
// 					const helpingData = dataLayer[0].shoptet.product.codes;

// 					// console.log(helpingData);

// 					c.each(function () {
// 						if ($(this).hasClass(dataCodeHelper)) {
// 							const innerText = $(this).html().replace(/\s/g, '');
// 							$(option_newLabel).attr("data-code-helper", innerText);
// 							const label = option_newLabel.closest(".advanced-parameter");
// 							// Projdi všechny objekty v poli helpingData

// 							helpingData.forEach(item => {

// 								if (item.code === innerText) {

// 									const quantity = item.quantity;

// 									if (quantity < 1) {
// 										// console.log("data-code-helper: " + innerText + ", quantity: " + quantity);
// 										label.addClass("dissable");
// 										// label.style.opacity = "0,5";
// 									}
// 								}
// 							});
// 						}
// 					});
// 				});
// 			}
// 		});
// 	}
// 	let detailParametersVariants = document.querySelectorAll(
// 		".detail-parameters td > select"
// 	);
// 	if (detailParametersVariants.length) {
// 		detailParametersVariants.forEach((variant) => {
// 			if (variant.hasAttribute("data-parameter-id")) {
// 				let variantId = variant.getAttribute("data-parameter-id");
// 				if (variantId) {
// 					variantsHandler(variantId);
// 				}
// 			}
// 		});
// 	}
// }

shoptet.scripts.setCustomCallback('shoptet.global.ShoptetPagePaginationUsed', function (args) {
	setTimeout(() => {
		const productsElement = document.querySelector('#products');
		if (productsElement) {
			const offsetTop = productsElement.getBoundingClientRect().top + window.pageYOffset - 300;
			window.scrollTo({
				top: offsetTop,
				behavior: 'smooth'
			});
		}
	}, 200);
});